import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c63c81f4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "inner-container"
};
const _hoisted_3 = {
  key: 0,
  class: "text-center text-3xl text-red-500"
};
const _hoisted_4 = {
  key: 2,
  class: "text-center text-3xl"
};
const _hoisted_5 = {
  class: "btns min-h-[60px]"
};
import { onUnmounted, ref, watch } from 'vue';
export default {
  __name: 'GraphMemory',
  props: {
    items: {
      type: Array,
      default: () => [0]
    },
    size: {
      type: Number,
      default: () => 3
    }
  },
  emits: ['answer'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const props = __props;
    console.log(props, 'props');
    const index = ref(-1);
    const status = ref(-1);
    let timer;
    const answer = ref([]);
    const start = () => {
      next();
    };
    const matrix = ref(Array.from({
      length: props.size * props.size
    }, (value, index) => index));
    watch(props, newVal => {
      console.log(newVal, 'newVal');
      matrix.value = Array.from({
        length: newVal.size * newVal.size
      }, (value, index) => index);
      console.log(matrix.value, 'matrix.value');
      answer.value = [];
      index.value = -1;
      status.value = -1;
      clearInterval(timer);
    });
    const next = () => {
      if (index.value >= props.items.length - 1) {
        status.value = 3;
        emit('answer', answer.value);
        return;
      }
      status.value = 0;
      timer = setTimeout(() => {
        status.value = 1;
        index.value += 1;
        timer = setTimeout(() => {
          status.value = 2;
          if (index.value < 2) {
            next();
          }
        }, 1000);
      }, 500);
    };
    onUnmounted(() => {
      clearInterval(timer);
    });
    const onChoosed = val => {
      answer.value.push(val);
      clearInterval(timer);
      next();
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [status.value === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, " + ")) : status.value === 1 ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "box",
        style: _normalizeStyle({
          'grid-template-columns': `repeat(${props.size}, minmax(0, 1fr))`
        })
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(matrix.value, item => {
        return _openBlock(), _createElementBlock("div", {
          key: item,
          class: "item",
          style: _normalizeStyle({
            backgroundColor: item === __props.items[index.value][0] ? 'black' : 'white'
          })
        }, null, 4);
      }), 128))], 4)) : status.value === 3 ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 完成 ")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_5, [status.value === -1 ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        type: "primary",
        onClick: start
      }, {
        default: _withCtx(() => [_createTextVNode("开始")]),
        _: 1
      })) : _createCommentVNode("", true), index.value > 1 && index.value < props.items.length && [1, 2].includes(status.value) ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createVNode(_component_el_button, {
        onClick: _cache[0] || (_cache[0] = $event => onChoosed('Y'))
      }, {
        default: _withCtx(() => [_createTextVNode("相同")]),
        _: 1
      }), _createVNode(_component_el_button, {
        onClick: _cache[1] || (_cache[1] = $event => onChoosed('N'))
      }, {
        default: _withCtx(() => [_createTextVNode("不同")]),
        _: 1
      })], 64)) : _createCommentVNode("", true)])]);
    };
  }
};